import React from "react";
import keyimg from "../Images/narenthimg.jpg";
import { FaEnvelope, FaPhoneAlt, FaLinkedin } from "react-icons/fa";

export default function Keypersonals() {
  return (
    <div className="bg-gray-100 min-h-screen py-20">

      {/* Heading */}

      <div className="text-center mb-14">

        <span className="uppercase tracking-[5px] text-amber-500 font-semibold">
          Leadership
        </span>

        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3">
          Key Personnel
        </h1>

        <p className="text-gray-600 mt-5 max-w-2xl mx-auto">
          Meet the leadership behind E&amp;D Rebar Service, committed to
          delivering quality, precision, and excellence in every project.
        </p>

      </div>

      {/* Profile Card */}

      <div className="max-w-4xl mx-auto px-6">

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">

          <div className="grid md:grid-cols-2">

            {/* Left Side */}

            <div className="bg-slate-900 flex items-center justify-center p-10">

              <img
                src={keyimg}
                alt="Narenth Kumar"
                className="w-72 h-72 rounded-full object-cover border-8 border-amber-400 shadow-xl"
              />

            </div>

            {/* Right Side */}

            <div className="p-10 flex flex-col justify-center">

              <span className="uppercase tracking-[4px] text-amber-500 font-semibold">
                Managing Director
              </span>

              <h2 className="text-4xl font-bold text-slate-900 mt-3">
                Narenth Kumar M
              </h2>

              <h3 className="text-xl text-gray-500 mt-2">
                MD & President
              </h3>

              <p className="text-gray-600 leading-8 mt-8">
                Experienced Rebar Estimator and Construction Professional with
                expertise in reinforcing steel estimation, project planning,
                quantity take-offs, and construction management. Dedicated to
                delivering accurate, cost-effective, and high-quality solutions
                for commercial, residential, and infrastructure projects.
              </p>

              <div className="mt-8 space-y-5">

                <div className="flex items-center gap-4">
                  <div className="bg-amber-100 p-3 rounded-full">
                    <FaEnvelope className="text-amber-600" />
                  </div>

                  <span className="text-gray-700">
                    Estimaterebbar@outlook.com
                  </span>
                </div>

                <div className="flex items-center gap-4">
                  <div className="bg-amber-100 p-3 rounded-full">
                    <FaPhoneAlt className="text-amber-600" />
                  </div>

                  <span className="text-gray-700">
                    +91 86672 78873
                  </span>
                </div>

                <div className="flex items-center gap-4">
                  <div className="bg-amber-100 p-3 rounded-full">
                    <FaLinkedin className="text-amber-600" />
                  </div>

                  <a
                    href="https://www.linkedin.com/in/narenthkumar-m-rebar-estimator-54711112b"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    LinkedIn Profile
                  </a>
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}